import { NgControl } from "@angular/forms";
import { Input, HostListener, Directive } from "@angular/core";
import { CommonService } from "../base-services/common.service";

@Directive({
    selector: '[addLeadingZeros]'
})
export class AddLeadingZerosDirective {
    constructor(private control: NgControl,
                private commonService: CommonService) {
    }

    @Input() addLeadingZeros: number;

    @HostListener('focusout')
    onFocusout() {
        if(this.control.value)
            this.control.control.setValue(this.commonService.PadLeft(this.control.value, '0', this.addLeadingZeros));
    }
}